import { SharedColDef, SharedGridOptions } from './shared-grid.model';

export abstract class SharedGridColumnsService {
  abstract columns(...args: any[]): SharedColDef[];

  abstract onColumnStateChanged(path: string): Pick<SharedGridOptions, 'onNewColumnsLoaded' | 'onDragStopped'>;
}
